import CounterpartyLegalPerson from "./CounterpartyLegalPerson";
import CounterpartyNaturalPerson from "./CounterpartyNaturalPerson";
import CounterpartySoleProprietorship from "./CounterpartySoleProprietorship";

export default function counterpartyBuilder(data) {
  if (data.counterparty.counterpartyType == "Legal person") {
    return CounterpartyLegalPerson.createFromData(data);
  } else if (data.counterparty.counterpartyType == "Natural person") {
    return CounterpartyNaturalPerson.createFromData(data);
  } else if (data.counterparty.counterpartyType == "Sole proprietorship") {
    return CounterpartySoleProprietorship.createFromData(data);
  } else {
    throw new Error("counterpartyBuilder for type " + data.counterparty.counterpartyType + "is not implimented");
  }
}
